import { instance, parseAxiosError } from "./backendApi";

const getList = async (resource, params) => {
    try {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
            ...params.filter,
            sortBy: `${field}:${order.toLowerCase()}`,
            limit: perPage,
            page,
        }
        const data = await instance.get(`/v1/${resource}`, { params: query })
            .then(response => response.data);
        return {
            data: data.results,
            total: data.totalResults,
        }
    } catch (error) {
        throw parseAxiosError(error);
    }
}

const getOne = async (resource, params) => {
    try {
        const data = await instance.get(`/v1/${resource}/${params.id}`)
            .then(response => response.data);
        return { data }
    } catch (error) {
        throw parseAxiosError(error);
    }
}

const getMany = async (resource, params) => {
    try {
        const promises = params.ids.map(id =>
            instance.get(`/v1/${resource}/${id}`)
                .then(response => response.data)
        )
        const data = await Promise.all(promises);
        return { data }
    } catch (error) {
        throw parseAxiosError(error);
    }
}

const getManyReference = async (resource, params) => {
    try {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
            ...params.filter,
            [params.target]: params.id,
            sortBy: `${field}:${order.toLowerCase()}`,
            limit: perPage,
            page,
        }
        const data = await instance.get(`/v1/${resource}`, { params: query })
            .then(response => response.data);
        return {
            data: data.results,
            total: data.totalResults,
        }
    } catch (error) {
        throw parseAxiosError(error);
    }
}

const create = async (resource, params) => {
    try {
        const data = await instance.post(`/v1/${resource}`, params.data)
            .then(response => response.data);
        return { data }
    } catch (error) {
        throw parseAxiosError(error);
    }
}

const update = async (resource, params) => {
    try {
        const data = await instance.patch(`/v1/${resource}/${params.id}`, params.data)
            .then(response => response.data);
        return { data }
    } catch (error) {
        throw parseAxiosError(error);
    }
}

const updateMany = async (resource, params) => {
    try {
        const promises = params.ids.map((id, index) =>
            instance.patch(`/v1/${resource}/${id}`, params.data[index])
                .then(response => response.data)
        )
        const data = await Promise.all(promises);
        return { data }
    } catch (error) {
        throw parseAxiosError(error);
    }
}

const _delete = async (resource, params) => {
    try {
        const data = await instance.delete(`/v1/${resource}/${params.id}`)
            .then(response => response.data);
        return { data }
    } catch (error) {
        throw parseAxiosError(error);
    }
}

const deleteMany = async (resource, params) => {
    try {
        const promises = params.ids.map(id =>
            instance.delete(`/v1/${resource}/${id}`)
                .then(response => response.data)
        )
        const data = await Promise.all(promises);
        return { data }
    } catch (error) {
        throw parseAxiosError(error);
    }
}

const dataProvider = {
    getList,
    getOne,
    getMany,
    getManyReference,
    create,
    update,
    updateMany,
    delete: _delete,
    deleteMany,
}

export default dataProvider
